export default {"src":"/_next/static/media/scuba_diving.bb5d611b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};